import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import NewReleases from "@/pages/home/components/NewReleases";
import AboutBand from "@/pages/home/components/AboutBand";
import LibraryGrid from "@/pages/home/components/LibraryGrid";
import PressGrid from "@/pages/home/components/PressGrid";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel />
        <NewReleases />
        <AboutBand />
        <LibraryGrid />
        <PressGrid />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}